// extracted by mini-css-extract-plugin
module.exports = {"txType":"styles_txType__L2ki1","txTypeText":"styles_txTypeText__XQvJl"};